/**
 * Keracraft Discount Input — Rabattcode-Feld im UpCart-Drawer bei LEEREM
 * Warenkorb (ESN-Muster). UpCart zeigt sein eigenes Code-Feld erst, wenn
 * Artikel im Warenkorb liegen; dieses Widget schließt die Lücke davor:
 *
 *  - Eingabefeld + "Anwenden" oben im leeren Drawer
 *  - Code wird doppelt aktiviert: im Warenkorb gespeichert
 *    (/cart/update.js, funktioniert nachweislich auch bei leerem Cart)
 *    UND als Session-Cookie (/discount/CODE) für die Regios-Anzeige
 *  - Aktive Codes erscheinen als Chip mit ✕ zum Entfernen
 *  - Sobald Artikel im Warenkorb liegen, entfernt sich das Widget und
 *    UpCarts natives Rabatt-Modul übernimmt (kein Doppel-Feld)
 *
 * Live verifiziert am 05.08.2026: Einfüge-Ziel ist der Container vor
 * [class*="CartPreview__empty__body"] in UpCarts Shadow DOM. UpCart
 * ersetzt beim Re-Rendern den KOMPLETTEN Shadow-Inhalt (inkl. fremder
 * Elemente) — deshalb läuft neben dem MutationObserver ein leichtes
 * 1s-Intervall als Sicherheitsnetz, das das Widget wieder einsetzt.
 *
 * Hinweis: Bei leerem Warenkorb kann Shopify Codes nicht validieren
 * (auch ungültige werden gespeichert, applicable=false). Die echte
 * Prüfung passiert, sobald der erste Artikel im Warenkorb liegt.
 */
(function () {
  'use strict';

  if (window.__kcDiscountInputLoaded) return;
  window.__kcDiscountInputLoaded = true;

  var WIDGET_ID = 'kc-discount-input';
  var STYLE_ID = 'kc-discount-input-styles';

  function findShadow() {
    var host = document.getElementById('upCart');
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function ensureStyles(root) {
    if (root.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      /* 30px seitlich = Innenabstand von UpCarts Rewards-Modul; der rechte
         Rand wird zur Laufzeit exakt auf das Geschenk-Icon des Balkens
         feinjustiert (siehe alignWithRewards) */
      '#kc-discount-input { padding: 12px 30px 4px; font-family: inherit; }',
      '#kc-discount-input .kcdi-row { display: flex; gap: 8px; }',
      '#kc-discount-input .kcdi-input { flex: 1; min-width: 0; height: 44px; padding: 0 12px; font-size: 14px; border: 1.5px solid #d1d1d1; border-radius: 8px; outline: none; box-sizing: border-box; }',
      '#kc-discount-input .kcdi-input:focus { border-color: #1a1a1a; }',
      /* Button in Theme-Optik: Keracraft-Pink, aber 8px-Ecken passend zum Feld */
      '#kc-discount-input .kcdi-apply { height: 44px; padding: 0 20px; border: none; border-radius: 8px; background: #E83168; color: #fff; font-size: 14px; font-weight: 600; cursor: pointer; }',
      '#kc-discount-input .kcdi-apply[disabled] { opacity: .5; cursor: wait; }',
      '#kc-discount-input .kcdi-chips { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }',
      /* Aktiv-Chip: grüner Rahmen + Haken-Kreis, 8px-Ecken passend zum Feld */
      '#kc-discount-input .kcdi-chip { display: inline-flex; align-items: center; gap: 8px; background: #f3faf5; border: 1.5px solid #2f7a4d; border-radius: 8px; padding: 6px 10px; font-size: 13px; font-weight: 400; color: #1a1a1a; }',
      '#kc-discount-input .kcdi-chip .kcdi-check { display: inline-flex; align-items: center; justify-content: center; width: 18px; height: 18px; border-radius: 50%; background: #2f7a4d; color: #fff; flex: none; }',
      '#kc-discount-input .kcdi-chip .kcdi-check svg { width: 11px; height: 11px; }',
      '#kc-discount-input .kcdi-chip button { display: inline-flex; align-items: center; justify-content: center; width: 18px; height: 18px; border: 1.5px solid #2f7a4d; border-radius: 50%; background: none; cursor: pointer; padding: 0; color: #2f7a4d; flex: none; }',
      '#kc-discount-input .kcdi-chip button svg { width: 9px; height: 9px; }'
    ].join('\n');
    root.appendChild(style);
  }

  function buildWidget() {
    var el = document.createElement('div');
    el.id = WIDGET_ID;
    el.innerHTML =
      '<div class="kcdi-row">' +
      '<input class="kcdi-input" type="text" placeholder="Code einfügen" autocomplete="off">' +
      '<button class="kcdi-apply" type="button">Anwenden</button>' +
      '</div>' +
      '<div class="kcdi-chips"></div>';

    var input = el.querySelector('.kcdi-input');
    var btn = el.querySelector('.kcdi-apply');
    var chips = el.querySelector('.kcdi-chips');

    function renderChips(codes) {
      chips.innerHTML = '';
      (codes || []).forEach(function (c) {
        var chip = document.createElement('span');
        chip.className = 'kcdi-chip';
        var label = document.createElement('span');
        // Grüner Haken-Kreis + Code in normaler Schriftstärke
        label.innerHTML =
          '<span class="kcdi-check"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"></path></svg></span>';
        var codeTxt = document.createElement('span');
        codeTxt.textContent = String(c.code).toUpperCase();
        var x = document.createElement('button');
        x.type = 'button';
        x.setAttribute('aria-label', 'Code entfernen');
        x.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"></path></svg>';
        x.addEventListener('click', function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: '' })
          })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              renderChips(cart.discount_codes);
              // Drawer-Summen und Seiten-Preise live aktualisieren
              if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
              if (window.KCSaleDisplay) window.KCSaleDisplay.refresh(cart);
            })
            .catch(function () {});
        });
        chip.appendChild(label);
        chip.appendChild(codeTxt);
        chip.appendChild(x);
        chips.appendChild(chip);
      });
    }

    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderChips(cart.discount_codes); })
        .catch(function () {});
    }

    function apply() {
      var code = (input.value || '').trim();
      if (!code) return;
      btn.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Session-Cookie für die Regios-Streichpreis-Anzeige setzen
          fetch('/discount/' + encodeURIComponent(code)).catch(function () {});
          input.value = '';
          btn.disabled = false;
          renderChips(cart.discount_codes);
          // Drawer-Summen und Seiten-Preise live aktualisieren
          if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
          if (window.KCSaleDisplay) window.KCSaleDisplay.refresh(cart);
        })
        .catch(function () { btn.disabled = false; });
    }

    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') apply();
    });

    // Live-Zustandswechsel: Wird ein Code woanders aktiviert/entfernt
    // (Buy-Box-Banner, Sommer-Sale-Banner, Cart-Wächter), meldet die
    // Sale-Display-Engine das per Event — Chip sofort aktualisieren.
    window.addEventListener('kc:sale-state', function (e) {
      if (!el.isConnected) return; // veraltete Widget-Instanz (Drawer neu gerendert)
      renderChips((e.detail && e.detail.codes) || []);
    });

    refresh();
    return el;
  }

  // Rechten Rand exakt auf das Geschenk-Icon am Ende des Fortschritts-
  // balkens ausrichten (UpCarts Icon kann leicht über den Innenabstand
  // des Moduls hinausragen). Läuft einmalig, sobald beides sichtbar ist.
  function alignWithRewards(root, widget) {
    if (widget.getAttribute('data-kc-aligned') === '1') return;
    var rewards = root.querySelector('[class*="upcart-internal-rewards"]');
    if (!rewards) return;
    var icons = rewards.querySelectorAll('svg, img');
    var lastIcon = icons.length ? icons[icons.length - 1] : null;
    var row = widget.querySelector('.kcdi-row');
    if (!lastIcon || !row) return;
    var iconRect = lastIcon.getBoundingClientRect();
    var rowRect = row.getBoundingClientRect();
    if (iconRect.width === 0 || rowRect.width < 50) return; // Drawer (noch) nicht sichtbar
    var diff = Math.round(iconRect.right - rowRect.right);
    if (diff !== 0 && Math.abs(diff) <= 24) {
      var current = parseFloat(getComputedStyle(widget).paddingRight) || 30;
      widget.style.paddingRight = Math.max(4, current - diff) + 'px';
    }
    widget.setAttribute('data-kc-aligned', '1');
  }

  function ensureWidget() {
    var root = findShadow();
    if (!root) return;
    var existingWidget = root.getElementById(WIDGET_ID);
    if (existingWidget) {
      alignWithRewards(root, existingWidget);
      return;
    }
    // IMMER anzeigen — leerer UND gefüllter Warenkorb (UpCarts eigenes
    // Rabatt-Modul ist in den UpCart-Einstellungen deaktiviert; dieses
    // Widget ist der vollwertige Ersatz).
    // Position: ganz oben im Drawer, direkt ÜBER dem Versand-
    // Fortschrittsbalken (Rewards-Leiste); Fallback: über dem Empty-Body.
    var rewards = root.querySelector('[class*="upcart-internal-rewards"]');
    var emptyBody = root.querySelector('[class*="CartPreview__empty__body"]');
    var anchor = (rewards && rewards.parentElement) ? rewards : emptyBody;
    if (!anchor || !anchor.parentElement) return; // Drawer noch nicht gerendert
    ensureStyles(root);
    anchor.parentElement.insertBefore(buildWidget(), anchor);
  }

  // Warten bis UpCart geladen ist (max. ~60s), dann Observer + Intervall
  var bootTries = 0;
  var boot = setInterval(function () {
    var root = findShadow();
    if (!root && ++bootTries < 150) return;
    clearInterval(boot);
    if (!root) return;
    ensureWidget();
    try {
      new MutationObserver(ensureWidget).observe(root, { childList: true, subtree: true });
    } catch (e) {}
    setInterval(ensureWidget, 1000);
  }, 400);
})();
